<template>
  <News :posts="posts" :translate="translate" />
</template>

<script setup>

// const { locale } = useI18n();
  
import { useTranslationStore } from '@/stores/translations';

const translationStore = useTranslationStore();
const translate = translationStore.translate;

const props = defineProps({
    posts: {
        type: [Object, Array],
        required: true,
    }
})

console.log('posts sd update');
console.log(props.posts);

// const fetchPosts = async () => {
//     const cachedPosts = await Promise.all(
//         posts.map(async (post) => ({
//             ...post,
//             id: post.id,
//             slug: post.slug,
//             title: post.title,
//             image: post.image,
//             date: post.date,
//             url: post.file ?? post.external_url ?? getUpdatesDetailUrl(category, post.id, post.slug),
//         }))
//     );

//     posts.value = cachedPosts;
// }

// const getManagementDetailUrl = (category, id, slug) => {  
//   return `${locale.value}/updates/${category}/${id}/${slug}`;
// };

// onMounted(() => {
//   fetchPosts();
// });
const News = defineAsyncComponent(() =>
  import(`@/components/apps/card/SdUpdates.vue`)
);

</script>